import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UnitListItemService } from '@app/shared/services';
import { UnitListItemsSetupComponent } from './unit-list-items-setup.component';
import { LinqFormsModule } from '../../forms/forms.module';
import { SharedModule } from '../../shared.module';

const components = [UnitListItemsSetupComponent];

@NgModule({
    exports: [...components],
    imports: [CommonModule, SharedModule, LinqFormsModule, ...components],
    providers: [UnitListItemService],
})
export class UnitListItemsModule {}
